import React from "react";
import "./Group683.css";

function Group683(props) {
  const { className } = props;

  return (
    <div className={`group-68-3 ${className || ""}`}>
      <img className="icon-label-4" src="/img/path-55@1x.png" />
      <div className="redeem-3 avenir-heavy-normal-eerie-black-4px">redeem</div>
    </div>
  );
}

export default Group683;
